/**
 * Initialization loading helper functions.
 */

/**
 * Services whose failure should be treated as critical (non-retryable).
 */
const CRITICAL_SERVICES = ["eventBus", "dataManager", "errorHandler"];

/**
 * Check if a service is critical (for error handling).
 */
export const isCriticalService = (serviceName: string): boolean =>
  CRITICAL_SERVICES.includes(serviceName);

/**
 * Calculate progress percentage based on completed/total services.
 */
export const calculateProgress = (completed: number, total: number): number => {
  if (total === 0) return 0;
  return Math.min(100, Math.round((completed / total) * 100));
};
